import SignupNoOtp from "../components/Auth/SignupNoOtp";

export default function SignupPage() {
  return <SignupNoOtp />;
}
